import { post, get } from '../../../../services/request';

//-------------------Annual Hour Tracker - start----------------//
// Get all annual hour tracker
export const getAllAnnualHourTracker = (payload) => {
    return post('Radiologist/GetRadQgendaScheduleEnterpriseDataWithPaginationPOC', payload);
};

// Get all annual hour tracker dropdown data
export const getAllAnnualHourTrackerDropdown = () => {
    return get('Radiologist/GetAllRadiologistQgendaScheduleEnterpriseDropdown');
};

// Get Worklist by RPCE Ids
export const getWorklistByRPCE = (rpceIds) => {
    const query = `isNeedToBindMRQ=true&rpceIds=${rpceIds.join(',')}`;
    return post(`Common/GetWorkListByRPCEIds?${query}`);
};

// Get Task by Worklist Ids
export const getTaskByWorklist = (worklistIds) => {
    const data = {
        worklistIds: worklistIds.join(','),
        IsExtraShift: 1
    };

    return post("Common/GetFilteredTasksByWorklistIds", data);
};

// Export for Annual Hour Tracker to CSV
export const exportCSVAnnualHourTracker = (url, payload) => {
    return post(url, payload);
};

// Refresh Annual Hour Tracker Data
export const refreshAnnualHourTracker = (payload) => {
    const data = {
        CreatedBy: payload?.userId,
        IsFromMiscSite: true,
        StartDate: payload?.fromDate,
        EndDate: payload?.toDate,
        AllowToMoveShifts: true
    };
    return post('Qgenda/GetQgendaTasksAndSchedules', data);
}
//-------------------Annual Hour Tracker - end----------------//